class Alert {
	static CustomClass() {
		return {
			confirmButton: "btn btn-primary mx-1 mb-1",
			cancelButton: "btn btn-secondary mx-1 mb-1",
			denyButton: "btn btn-info mx-1 mb-1"
		};
	}

	static Confirm(title, text, confirmButtonText = null, options = {}) {

		if(confirmButtonText === null) confirmButtonText = __("Confirm");

		let customClass = Alert.CustomClass();
		if(options.customClass) {
			customClass = $.extend(customClass, options.customClass);
			delete options.customClass;
		}

		const config = $.extend({
			title: title,
			text: text,
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: confirmButtonText,
			customClass: customClass,
			buttonsStyling: false,
			heightAuto: false,
			reverseButtons: true,
			allowOutsideClick: false,
		}, options);

		if(options.returnConfig) {
			delete config.returnConfig;
			return config;
		}

		return Swal.fire(config);
	}

	static DeleteConfirm(text, preConfirmCallback, options = {}) {
		const config = $.extend({
			title: __("Are you sure?"),
			text: text,
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: __("Delete"),
			customClass: Alert.CustomClass(),
			buttonsStyling: false,
			heightAuto: false,
			reverseButtons: true,
			preConfirm: preConfirmCallback,
			allowOutsideClick: false,
		}, options);

		if(options.returnConfig) {
			delete config.returnConfig;
			return config;
		}

		return Swal.fire(config);
	}

	static Success(title, text, options = {}) {
		const config = $.extend({
			title: title,
			text: text,
			icon: "success",
			customClass: Alert.CustomClass(),
			heightAuto: false,
			buttonsStyling: false,
			reverseButtons: true,
			allowOutsideClick: false,
		}, options);

		if(options.returnConfig) {
			delete config.returnConfig;
			return config;
		}

		return Swal.fire(config);
	}

	static Info(title, text, options = {}) {
		return Swal.fire($.extend({
			title: title,
			text: text,
			icon: "info",
			customClass: Alert.CustomClass(),
			heightAuto: false,
			buttonsStyling: false,
			reverseButtons: true,
			allowOutsideClick: false,
		}, options));
	}

	static Error(title, text, options = {}) {
		return Swal.fire($.extend({
			title: title,
			text: text,
			icon: "error",
			customClass: Alert.CustomClass(),
			heightAuto: false,
			buttonsStyling: false,
			reverseButtons: true,
			allowOutsideClick: false,
		}, options));
	}
}
